import React, { useState } from "react";
import { PowerBIEmbed } from "powerbi-client-react";
import { IEmbedConfiguration } from "powerbi-client";
import { TokenType } from "powerbi-models";
import ContentPage from "../../components/ContentPage";
import DashboardSelector from "./components/dashboard-selector/DashboardSelector";
import getEmbedDetails from "./http/getEmbedDetails";
import styles from "./Dashboard.module.scss";
import useMegatron from "../../hooks/useMegatron";
import { upgradeToProText } from "../../constants/ToolTipsText";
import { getUserId, isMegatronFeatureOn, isMegatronProUser } from "../../Authentication/Auth";
import { trackEvent } from "../../util/googletagmanager/GTM";


const DashboardsNew = () => {
  const [
    selectedDashboard,
    setSelectedDashboard,
  ] = useState<IEmbedConfiguration | null>(null);
  const [embedError, setEmbedError] = useState(false);
  const {isLoading, megatronLiteUser, isMegatronFeaturedOn} = useMegatron();

  const getDashboardDetails = (id: number) => {
    setEmbedError(false);
    const megatronProUser = getUserId() != undefined && isMegatronProUser() && isMegatronFeatureOn;
    if(megatronProUser)
     {
        trackEvent('Feature_Interaction',{
        User_Role:"Company user Pro",
        Tab_Section:"Analytics",
        Type:"Dropdown",
        Feature_Function:"Select a dashboard",
        UserInput:"Dropdown"})
     };
    getEmbedDetails(id)
      .then(({ data }) => {
        setSelectedDashboard({
          id: data.reportId,
          tokenType: TokenType.Embed,
          type: "report",
          embedUrl: data.embedUrl,
          pageName: data.name,
          accessToken: data.embedToken,
        });
      })
      .catch(() => setEmbedError(true));
  };

  // While feature flag is on and user is a lite user, they should not be able to access /private/dashboard
  if(!isLoading && megatronLiteUser && isMegatronFeaturedOn) 
  {
    return <div>{upgradeToProText}</div>
  }


  return (
    <ContentPage title="Analytics">
      <div className={styles.dashboardSelector}>
        <DashboardSelector onDashboardSelect={getDashboardDetails} />
      </div>
      {embedError && <p>Could not load the selected dashboard.</p>}
      {selectedDashboard && (
        <div>
          {selectedDashboard.pageName && <h3>{selectedDashboard.pageName}</h3>}
          <PowerBIEmbed
            embedConfig={selectedDashboard}
            cssClassName={styles.dashboardContainer}
          />
        </div>
      )}
    </ContentPage>
  );
};

export default DashboardsNew;
